import { render } from "./GMap.vue?vue&type=template&id=04d5fdc2&scoped=true"
import script from "./GMap.vue?vue&type=script&lang=js"
export * from "./GMap.vue?vue&type=script&lang=js"

import "./GMap.vue?vue&type=style&index=0&id=04d5fdc2&scoped=true&lang=css"

import exportComponent from "/Data/maps/detention/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d5fdc2"]])

export default __exports__